import { Booking } from '../../../APIDocs/apiTypes';
import { feedbackColour } from '../components/ListItem';
import { Logger } from '../Logger';

export const getFeedbackColourForBookingStatus = (status: Booking['Status']): feedbackColour => {
  switch (status) {
    case 'Aborted':
      return feedbackColour.red;
    case 'Cancelled':
      return feedbackColour.orange;
    case 'Completed':
      return feedbackColour.green;
    case 'Scheduled':
      return feedbackColour.blue;
    default: {
      const error = `Unexpected job status: ${status} when processing determineFeedbackColourForBooking`;
      Logger.Error(error);
      throw error;
    }
  }
};

export const getFeedbackColour = (fbColour: feedbackColour | undefined) => {
  switch (fbColour) {
    case feedbackColour.blue:
      return ['border-feedback-blue', 'bg-feedback-blue'];
    case feedbackColour.green:
      return ['border-feedback-green', 'bg-feedback-green'];
    case feedbackColour.orange:
      return ['border-feedback-orange', 'bg-feedback-orange'];
    case feedbackColour.red:
      return ['border-feedback-red', 'bg-feedback-red'];
    case feedbackColour.redText:
      return ['border-feedback-red-text', 'bg-feedback-red-text'];
    case feedbackColour.yellow:
      return ['border-feedback-yellow', 'bg-feedback-yellow'];
    default:
      return ['', ''];
  }
};
